import { gql } from "@grandvisionhq/graphql";
import { productFragment } from "../../fragments/operations/queries/fragments/product.js";
import { variantFragment } from "../../fragments/operations/queries/fragments/variant.js";
import { commercialCategoryFragment } from "../../fragments/operations/queries/fragments/small-fragments.js";
const GET_CONTACT_LENS_BY_SLUG = gql`
  query GetContactLensBySlug($slug: String!) {
    getProductBySlug(slug: $slug) {
      product {
        __typename
        ... on ContactLensProduct {
          id
          ...productFragment
          productTypeDetails {
            isMaster
            productMasterKey
            replacementFrequency
            replacementFrequencyAllLocales {
              locale
              value
            }
          }
          commercialCategories {
            ...CommercialCategoryFragment
          }
          variants {
            ...variantFragment
            gan
            variantTypeDetails {
              channelAvailability
              color
              hasBetterAllRoundVision
              hasBetterHydration
              hasEnhancedSoftness
              hasIncreasedBreathability
              hasLessFatigue
              hasUvProtection
              isMaster
              lensType
              lensTypeAllLocales {
                locale
                value
              }
              masterVariantSku
              material
              materialAllLocales {
                locale
                value
              }
              materialType
              maxQuantityPerVariant
              opticalRanges {
                addition
                axis
                baseCurve
                cylinder
                diameter
                power
              }
              packageQuantity
              recommendedCategoryKey
              waterContent
              subscriptionIntervals
            }
          }
        }
      }
    }
  }
  ${productFragment}
  ${commercialCategoryFragment}
  ${variantFragment}
`;
export {
  GET_CONTACT_LENS_BY_SLUG
};
//# sourceMappingURL=get-contact-lens-by-slug.js.map
